import { useCallback, useContext } from 'react';
import ConditionalTile, {
  type ConditionalTileData
} from '@/srp/ConditionalTiles/ConditionalTile';
import SearchSource from '~/constants/srp/SearchSource';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import { useIsMobile } from '~/context/srp/DeviceContext';
import SearchEventsDataContext from '~/context/srp/SearchEventsDataContext';
import ClickableTile from './ClickableTile';

export default function KeepMovingTile() {
  const isMobile = useIsMobile();
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const { setAppliedFilters } = useContext(AppliedFiltersContext);

  const data: ConditionalTileData = {
    content: {
      heading1: 'Save $1,500+ with these great deals',
      subHeading:
        'Browse cars that save you $1,500 or more vs. Kelley Blue Book® Typical Listing Price. '
    },
    button: 'Shop Now',
    tooltip: {
      strong: 'Great Deal',
      text: 'Savings amount based on the difference between Kelley Blue Book® Typical Listing Price and current Carvana listing price, not including tax, title, registration, or delivery charges. Savings amounts are updated daily.'
    }
  };

  const style = {
    background: `linear-gradient(180deg, rgba(24, 53, 88, 0.65) 0%, rgba(24, 53, 88, 0) 100%), url(${process.env.CVNA_APP_ASSETS_CDN}/serenity-ui/images/keep-moving-tile.jpg)`,
    backgroundSize: 'cover',
    backgroundPositionY: '94%'
  };

  const onClick = useCallback<React.MouseEventHandler>(
    ev => {
      ev.preventDefault();

      setAppliedFilters({
        tagIds: ['104']
      });

      setSearchSource(SearchSource.Tile);
    },
    [setAppliedFilters, setSearchSource]
  );

  return (
    <ClickableTile
      tileId="GreatDealTile"
      name="GreatDealTile"
      backgroundLink={`${process.env.CVNA_APP_ASSETS_CDN}/serenity-ui/images/keep-moving-tile.jpg`}
      handleBackground="bottom"
      bgOffsetY="94%"
      darkenBackground
      experiment
      handleTileClick={onClick}
      style={style}
      analyticsId="Great Deal Tile"
      nativeIncluded={false}
    >
      <ConditionalTile
        light
        top
        hasButton
        hideIcon
        backgroundButton
        isMobile={isMobile}
        data={data}
      />
    </ClickableTile>
  );
}
